import { useEffect, useState } from 'react'
import { Music, Coffee, BookOpen, Image as ImageIcon, Activity } from 'lucide-react'

const SECTIONS = [
  { id: 'music', label: 'Music', icon: Music },
  { id: 'food', label: 'Food', icon: Coffee },
  { id: 'reading', label: 'Reading', icon: BookOpen },
  { id: 'photos', label: 'Photos', icon: ImageIcon },
  { id: 'signal-log', label: 'Signal Log', icon: Activity },
]

export default function StickyNav() {
  const [active, setActive] = useState<string>('music')

  useEffect(() => {
    const handler = () => {
      let current = SECTIONS[0].id
      for (const s of SECTIONS) {
        const el = document.getElementById(s.id)
        if (!el) continue
        const top = el.getBoundingClientRect().top
        if (top < 140) current = s.id
      }
      setActive(current)
    }
    handler()
    window.addEventListener('scroll', handler, { passive: true })
    return () => window.removeEventListener('scroll', handler)
  }, [])

  return (
    <nav
      aria-label="After Hours sections"
      className="sticky top-[57px] z-30 backdrop-blur-md bg-navy-900/70 border-b border-amber-400/15"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3">
        <ul className="flex items-center gap-2 sm:gap-4 overflow-x-auto">
          {SECTIONS.map(({ id, label, icon: Icon }) => {
            const isActive = active === id
            return (
              <li key={id}>
                <a
                  href={`#${id}`}
                  className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors border ${
                    isActive
                      ? 'border-amber-300 text-amber-100 bg-amber-400/10'
                      : 'border-transparent text-amber-100/60 hover:text-amber-100 hover:border-amber-400/30'
                  }`}
                  aria-current={isActive ? 'true' : undefined}
                >
                  <Icon size={14} />
                  <span>{label}</span>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </nav>
  )
}
